import { defineComponent as _defineComponent } from 'vue'
import { withDefaults } from "vue";
import EmptyDefault from "./assets/imgs/empty-default.png";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    title: { default: "没有任何数据" },
    desc: { default: "请先新增" }
  },
  setup(__props: any) {

const props = __props as { title: string, desc: string }



return { __sfc: true,props, EmptyDefault }
}

})